import Vue from 'vue'
import store from '@/store'
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { i18nRender } from '@/locales'
import { encrypt } from '@/utils/util'

import {
  ACCESS_TOKEN
  // LANGUAGE
} from '@/store/mutation-types'
import api from '@/api/index'
// 创建 axios 实例
const service = axios.create({
  baseURL: window.location.href.includes('http://localhost') ? '/apisso' : process.env.VUE_APP_BASE_API,
  timeout: 60000 // 请求超时时间
})

const handleError = (error) => {
  const { response } = error
  const ignoreURL = [
    api.Logout,
    api.DingTalkNotice
  ]

  if (response && response.status === 401 && !ignoreURL.includes(response.config.url)) {
    console.log('systemLeave', store.getters.localDefaultConfig?.systemLeave)
    if (!store.getters.localDefaultConfig?.systemLeave) {
      store.dispatch('SetLocalDefaultConfig', {
        systemLeave: true
      })
      store.dispatch('Logout')
    }
  }

  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use((config) => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  // const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'

  if (token) {
    config.headers['Authorization'] = `${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
    store.getters.localDefaultConfig?.systemLeave && store.dispatch('SetLocalDefaultConfig', {
      systemLeave: false
    })
  }

  // config.headers['Accept-Language'] = lang
  // 需加密API
  const url = config.url.replace(/^\//, '')
  const encryptApis = {
    'sso/user/login': ['password'],
    'sso/user/register': ['password'],
    'sso/user/userEditPass': ['newPass', 'oldPass'],
    'sso/user/firstBindingPhoneEmailPsw': ['password', 'secondPsw'],
    'sso/user/addOrEditUserInfo': ['password'],
    'sso/dingTalk/registerDingTalkUser': ['passWord'],
    'sso/user/retrievePassByPhone': ['password'],
    'sso/user/retrievePassByEmail': ['password'],
    'sso/user/editStaffPassword': ['password'],
    'sso/user/appStoreLogin': ['password']
  }

  if (encryptApis[url]) {
    for (let i of encryptApis[url]) {
      if (config.data[i]?.length) {
        config.data[i] = encrypt(config.data[i])
      }
    }
  }
  return config
}, handleError)

// response interceptor
service.interceptors.response.use((response) => {
  const { url } = response.config

  const whiteList = [
    '/sso/serviceInfo/noticeThirdSystemClearCache'
  ]
  if (whiteList.includes(url)) {
    return response.data
  }

  if (`${response?.data?.code}` === '200' || `${response?.data?.code}` === '0') {
    const { authorization } = response.headers
    if (authorization) {
      Vue.ls.set(ACCESS_TOKEN, authorization)
    }
    return response.data
  } else if (response.data.code === 'saas.sso.subject.service.info.error.code.0015') {
    notification.open({
      prefixCls: 'home-ant-notification',
      message: '异常提醒',
      description: response.data.message,
      type: 'warning',
      btn: h => (
        <a-button type="primary" prefixCls="home-ant-btn" size="small" on={ { click: () => (window.location.href = '/') } }>返回首页</a-button>
      ),
      closeIcon: h => <span style="display:none"></span>
    })
  } else {
    const key = response.data ? response.data.code : ''
    notification.warning({
      prefixCls: 'home-ant-notification',
      key: key,
      message: i18nRender('notification-modal.title.prompt'),
      description: (response.data && response.data.message) || '请求出现错误，请稍后再试'
    })
    return Promise.reject(response.data)
  }
}, handleError)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
